import { ShieldCheck } from "lucide-react"

import { lazyPage } from "../lazy-page"
import { defineDashboardModule } from "../types"

export const legal = defineDashboardModule({
  id: "legal",
  nav: [
    {
      group: "Publishing",
      title: "Privacy policy",
      to: "/legal/privacy",
      icon: ShieldCheck,
    },
  ],
  routes: [
    {
      path: "/legal/:slug",
      component: lazyPage(() => import("./routes/legal-page"), "LegalPage"),
    },
  ],
})
